<template>
  <div class="info-box">
    <div class="flex-1 flex flex-col gap-y-5 overflow-hidden">
      <ul class="flex items-center gap-x-5 flex-wrap gap-y-2">
        <c_cell title="关键字">
          <template #default>
            <el-input
              v-model="state.params.keywords"
              placeholder="请输入关键字"
            ></el-input>
          </template>
        </c_cell>
        <c_cell title="乙方单位">
          <template #default>
            <el-select v-model="state.params.bill_unit_id" filterable class="!w-72">
              <template #label="{ value }">
                <div
                  v-if="yfdw_map.get(value)"
                  class="grid w-full items-center gap-x-10"
                  style="grid-template-columns: 1fr auto"
                >
                  <text>{{ yfdw_map.get(value).name }}</text>
                  <text class="text-gray-400 text-xs">
                    {{ yfdw_map.get(value).number }}
                  </text>
                </div>
              </template>
              <el-option
                v-for="item in state.yfdw_data"
                :key="item.id"
                :label="`${item.name} ${item.number}`"
                :value="item.id"
              >
                <div
                  class="grid w-full items-center gap-x-10"
                  style="grid-template-columns: 1fr auto"
                >
                  <text>{{ item.name }}</text>
                  <text class="text-gray-400 text-xs">
                    {{ item.number }}
                  </text>
                </div>
              </el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadYfdw()"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </template>
        </c_cell>
        <c_cell title="所属分会">
          <template #default>
            <el-select v-model="state.params.meeting_place_id" filterable class="!w-72">
              <template #label="{ value }">
                <div
                  v-if="fh_map.get(value)"
                  class="grid w-full gap-x-10 items-center"
                  style="grid-template-columns: 1fr auto"
                >
                  <text>{{ fh_map.get(value).name }}</text>
                  <text class="text-gray-400 text-xs">
                    {{ fh_map.get(value).hotel?.name + "-" + fh_map.get(value).hotelHall?.name }}
                  </text>
                </div>
              </template>
              <el-option
                v-for="item in state.fh_data"
                :key="item.id"
                :label="`${item.name} ${item.hotel?.name} ${item.hotelHall?.name}`"
                :value="item.id"
              >
                <div
                  class="grid w-full gap-x-10 items-center"
                  style="grid-template-columns: 1fr auto"
                >
                  <text>{{ item.name }}</text>
                  <text class="text-gray-400 text-xs">
                    {{ item.hotel?.name + "-" + item.hotelHall?.name }}
                  </text>
                </div>
              </el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadFh()"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </template>
        </c_cell>
        <el-button type="primary" @click="onLoad">搜索</el-button>
        <div class="flex justify-end flex-1 items-center gap-x-1">
          <text>报账金额合计:</text>
          <c_money :key="state.total" :value="state.total" bold />
        </div>
      </ul>
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        max-height="65vh"
        border
        style="border-color: #f00"
      >
        <el-table-column>
          <template #header>
            <div
              class="c-table-col-header"
              label1="所属分会"
              label2="乙方单位"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <text>{{ row.meetingPlace?.name }}</text>
              </template>
              <template #bottom>
                <text>{{ row.billUnit?.name }}</text>
                <text class="text-gray-400 text-xs ml-1">
                  {{ "[" + row.billUnit?.number + "]" }}
                </text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="采购名称" label2="供应商" />
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <text>{{ row.meetingPurchase?.name }}</text>
                <text class="text-gray-400 text-xs ml-1">
                  {{ row.meetingPurchase?.number }}
                </text>
              </template>
              <template #bottom>
                <div v-if="row.supplier_id" class="flex items-center gap-x-1">
                  <text>{{ row.supplier?.name }}</text>
                  <text class="text-gray-400 text-xs">
                    {{ row.supplier?.number }}
                  </text>
                </div>
                <text v-else>-</text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="采购项" label2="规格" />
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <text>[{{ row.d_cost_type_name }}]</text>
                <strong>{{ row.name }}</strong>
              </template>
              <template #bottom>
                <text>{{ row.specification }}</text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="类型" :width="140">
          <template #default="{ row }">
            <el-select v-model="row.d_cost_type_pid">
              <el-option
                v-for="item in state.cblx_data"
                :key="item"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="采购合计">
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <text>{{ row.bill_amount }}</text>
              </template>
              <template #bottom>
                <text>
                  {{
                    row.bill_price +
                    "*" +
                    row.bill_count +
                    row.d_measure_unit_name
                  }}
                </text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="备注" :width="260">
          <template #default="{ row }">
            <el-input v-model="row.remark" @focus="$onFocus" />
          </template>
        </el-table-column>
        <el-table-column align="center" :width="200">
          <template #header>
            <div class="flex items-center gap-x-1 justify-center">
              <div class="c-table-col-header" label1="报账数量" label2="天数"></div>
            </div>
          </template>
          <template #default="{ row }">
            <div class="grid grid-cols-2 gap-x-1">
              <el-input-number
                v-model="row.count"
                class="!w-full"
                placeholder="数量"
                @focus="$onFocus"
                @change="onBuildRowTotal(row)"
              />
              <el-input-number
                v-model="row.day_count"
                class="!w-full"
                placeholder="天数"
                @focus="$onFocus"
                @change="onBuildRowTotal(row)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="报账单价" align="center" :width="140">
          <template #default="{ row }">
            <el-input-number
              v-model="row.price"
              class="!w-full"
              precision="2"
              placeholder="报账单价"
              @focus="$onFocus"
              @change="onBuildRowTotal(row)"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="报账金额"
          align="right"
          prop="amount"
          :formatter="$tab_MoneyFormat"
          :width="140"
        />
      </el-table>
    </div>
    <div class="submit-box px-2.5">
      <el-button type="warning" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, reactive } from "vue";

import {
  meeting_bill_item_page,
  meeting_bill_item_editBatch,
} from "@/http/meeting";
import {
  data_getBillUnit,
  data_getMeetingPlace,
  dic_getCostType,
} from "@/http/data";
import { toDecimal, post_response } from "@/utils/funcs";
import { ElMessageBox } from "element-plus";

import c_add from "./Add/Info.vue";

export default {
  components: { c_add },
  props: {
    meeting_id: Number, //会议Id
    meeting_bill_id: Number, //会议报账单Id
    search: Boolean,
  },
  setup(props, { emit }) {
    const state = reactive({
      params: {
        meeting_id: props.meeting_id,
        limit: 0,
      },
    });
    onMounted(() => {
      onLoadYfdw();
      onLoadFh();
      onLoadCblx();
      if (props.meeting_bill_id) {
        state.params.meeting_bill_id = props.meeting_bill_id;
      }

      onLoad();
    });

    //获取乙方单位
    const onLoadYfdw = () => {
      data_getBillUnit().then((res) => {
        if (res.status == 200) state.yfdw_data = res.data?.data?.list || [];
      });
    };

    //获取分会
    const onLoadFh = () => {
      data_getMeetingPlace(props.meeting_id).then((res) => {
        if (res.status == 200) state.fh_data = res.data?.data?.list || [];
      });
    };

    //获取成本类型
    const onLoadCblx = () => {
      dic_getCostType({ pid: 0 }).then((res) => {
        if (res.status == 200) state.cblx_data = res.data?.data || [];
      });
    };

    //乙方单位 id 索引，O(1) 查找
    const yfdw_map = computed(() => {
      const m = new Map();
      state.yfdw_data?.forEach((item) => m.set(item.id, item));
      return m;
    });

    //分会 id 索引，O(1) 查找
    const fh_map = computed(() => {
      const m = new Map();
      state.fh_data?.forEach((item) => m.set(item.id, item));
      return m;
    });

    const onLoad = () => {
      delete state.list_data;

      meeting_bill_item_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count, statistics } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
          state.statistics = statistics;
          state.total = statistics.total_amount;
        }
      });
    };

    //采购单价、数量、天数改变时，计算行内合计，合计=采购单价*数量*天数
    const onBuildRowTotal = (row) => {
      if (typeof row.price == "number" && typeof row.count == "number") {
        row.amount = toDecimal(row.price.toString() || "")
          .times(toDecimal(row.count.toString() || ""))
          .times(toDecimal((row.day_count || "1").toString()));

        onBuildTotal();
      }
    };

    //计算总合计
    const onBuildTotal = () => {
      const total = state.list_data.reduce((pre, cur) => {
        return pre.plus(toDecimal(cur.amount?.toString() || ""));
      }, toDecimal("0"));
      state.total = total;
    };

    const onSubmit = () => {
      ElMessageBox.confirm(`您确定修改报账单吗`, "修改", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        customClass: "c-delete-dialog",
        cancelButtonClass: "is-plain",
      }).then(() => {
        meeting_bill_item_editBatch({
          batch_data: state.list_data,
        }).then((res) => {
          emit("refresh");
          post_response(res, onLoad);
        });
      });
    };

    return {
      state,
      props,
      yfdw_map,
      fh_map,
      onLoadYfdw,
      onLoadFh,
      onBuildRowTotal,
      onSubmit,
    };
  },
};
</script>

<style lang="less" scoped></style>
